import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import adobeLogo from '../../images/adobe-pdf-icon.png';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import Tooltip from '@material-ui/core/Tooltip';
import { PUBLIC_PATH } from 'constants/index';
import GridOnIcon from '@material-ui/icons/GridOn';
import EventNoteIcon from '@material-ui/icons/EventNote';

const ContractGrid = (props) => {

  const cards = (contract) => {
    const isNoResult=contract?.status?(contract.status.toLowerCase()==="no results"):false;

    return (
      <Paper elevation={2} className='contract-card'>
        <h4>{contract.filename}</h4>
        <Grid container direction='row' justifyContent='space-between'>
          <Grid item xs={2}>
            <img src={adobeLogo} style={{ marginLeft: -15 }} />
          </Grid>
          <Grid item xs={9} className='info' style={{ lineHeight: 1.4 }}>
            <p className='file-name'>
              <strong>File:</strong> <span
              title={contract.originalName ? contract.originalName : ''}>{contract.originalName ? contract.originalName : ''}</span>
            </p>
            <p>
              <strong>Date:</strong> {contract.createdDate ? new Date(contract.createdDate).toLocaleDateString() : '-'}
            </p>
            <p>
              <strong>Status:</strong> {isNoResult?<span style={{color:'red'}} >No Results</span>:<span style={{color:'green'}} >Processed</span>}
            </p>
            <p className='file-name' title={contract.createdByName}>
              <strong>Uploaded By:</strong> {contract.createdByName}
            </p>
          </Grid>
        </Grid>
        <div className='icons'>
          <div style={{marginLeft:-10, marginRight: -10}}>
            {(contract.clauses && contract.clauses.length > 0) && <Tooltip title="View Top 10 Cluases">
              <IconButton onClick={() => {
                props.history.push({
                  pathname: `/${PUBLIC_PATH}${props.match.params.appid}/top10/${contract._id}`,
                })
              }}>
                <SvgIcon className="icon">
                <g id="surface1">
                  <path style={{ stroke: "none", fillRule: "nonzero", fill: "rgb(0%,0%,0%)", fillOpacity: 1 }}
                        d="M 12 0 C 15.3125 0 18.3125 1.34375 20.484375 3.515625 C 22.65625 5.6875 24 8.6875 24 12 C 24 18.625 18.625 24 12 24 C 8.6875 24 5.6875 22.65625 3.515625 20.484375 C 1.34375 18.3125 0 15.316406 0 12 C 0 8.6875 1.34375 5.6875 3.515625 3.515625 C 5.6875 1.34375 8.6875 0 12 0 Z M 11.710938 11.929688 C 11.710938 10.09375 12.042969 8.8125 12.703125 8.078125 C 13.363281 7.347656 14.371094 6.980469 15.71875 6.980469 C 16.371094 6.980469 16.90625 7.058594 17.320312 7.21875 C 17.738281 7.378906 18.078125 7.589844 18.339844 7.84375 C 18.605469 8.101562 18.8125 8.371094 18.960938 8.652344 C 19.113281 8.9375 19.234375 9.265625 19.328125 9.644531 C 19.507812 10.363281 19.597656 11.117188 19.597656 11.898438 C 19.597656 13.648438 19.300781 14.925781 18.707031 15.742188 C 18.117188 16.550781 17.097656 16.960938 15.648438 16.960938 C 14.835938 16.960938 14.179688 16.828125 13.679688 16.570312 C 13.175781 16.3125 12.769531 15.933594 12.445312 15.433594 C 12.214844 15.078125 12.03125 14.59375 11.902344 13.976562 C 11.777344 13.359375 11.710938 12.679688 11.710938 11.929688 Z M 14.367188 11.9375 C 14.367188 13.164062 14.476562 14.003906 14.695312 14.453125 C 14.914062 14.902344 15.226562 15.125 15.640625 15.125 C 15.914062 15.125 16.148438 15.03125 16.347656 14.84375 C 16.546875 14.652344 16.695312 14.347656 16.789062 13.9375 C 16.882812 13.523438 16.929688 12.878906 16.929688 12.007812 C 16.929688 10.726562 16.824219 9.867188 16.601562 9.425781 C 16.382812 8.984375 16.058594 8.765625 15.625 8.765625 C 15.179688 8.765625 14.859375 8.988281 14.660156 9.4375 C 14.464844 9.882812 14.367188 10.71875 14.367188 11.9375 Z M 9.929688 6.980469 L 9.929688 16.796875 L 7.214844 16.796875 L 7.214844 10.375 C 6.777344 10.707031 6.351562 10.976562 5.941406 11.179688 C 5.53125 11.382812 5.015625 11.582031 4.398438 11.765625 L 4.398438 9.585938 C 5.3125 9.289062 6.023438 8.929688 6.523438 8.519531 C 7.03125 8.101562 7.425781 7.589844 7.710938 6.984375 L 9.929688 6.984375 Z M 19.679688 4.324219 C 17.710938 2.359375 15 1.140625 12 1.140625 C 9 1.140625 6.289062 2.359375 4.324219 4.320312 C 2.359375 6.289062 1.140625 9 1.140625 12 C 1.140625 14.996094 2.359375 17.710938 4.320312 19.679688 C 6.289062 21.640625 9 22.859375 12 22.859375 C 17.996094 22.859375 22.859375 17.996094 22.859375 12 C 22.859375 9 21.640625 6.289062 19.679688 4.324219 Z M 19.679688 4.324219 " />
                </g>
              </SvgIcon>
              </IconButton>
            </Tooltip>}
            <Tooltip title='View'>
              <IconButton onClick={() => {
                props.history.push({
                  pathname: `/${PUBLIC_PATH}${props.match.params.appid}/basiccontractview/${contract._id}`,
                })
              }}>
                <VisibilityIcon className='icon' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Edit'>
              <IconButton onClick={() => {
                props.history.push({
                  pathname: `/${PUBLIC_PATH}${props.match.params.appid}/contract-annotation/${contract._id}`,
                })
              }}>
                <EditIcon className='icon' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton onClick={() =>
                props.onDeleteContract({ ids: [contract._id], appid: props.match.params.appid })}>
                <DeleteIcon className='icon' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Tables'>
              <IconButton onClick={() =>
                  props.history.push({
                    pathname: `/${PUBLIC_PATH}${props.match.params.appid}/table-insights/${contract._id}`,
                  })}>
                <GridOnIcon className='icon' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Footnotes'>
              <IconButton onClick={() =>
                  props.history.push({
                    pathname: `/${PUBLIC_PATH}${props.match.params.appid}/footnotes/${contract._id}/view`,
                  } )}>
                <EventNoteIcon className='icon' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Download insights of this contract as excel'>
              <IconButton onClick={() => props.downloadAnnotations(contract._id)}>
                <GetAppIcon className='icon' />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </Paper>
    );
  };

  return (
    <div className="content-body">
      <Grid container spacing={3}>
        <Grid item xs={3} sm={3} className="flex-center">
          {/* <Link to="/contractlist"> */}
          <div className="block" onClick={() => {
            props.user.subscription !== 'basic' ?
              props.history.push({
                pathname: `/${PUBLIC_PATH}${props.match.params.appid}/contract-insights`,
              })
              :
              props.history.push({
                pathname: `/${PUBLIC_PATH}${props.match.params.appid}/contract-insights`,
              })
          }}>
            <AddIcon className="plusIcon" />
            <label>Add New</label>
          </div>
          {/* </Link> */}
        </Grid>
        {
          props.contracts && Array.isArray(props.contracts) && props.contracts.map((contract) => {
            return (
              <Grid key={contract._id} item xs={3} sm={3}>
                {cards(contract)}
              </Grid>
            );
          })
        }

      </Grid>
    </div>
  );
};

export default ContractGrid;
